"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isParentValue = _interopRequireDefault(require("../parcelData/isParentValue"));

var _equals = _interopRequireDefault(require("unmutable/lib/equals"));

var _default = function _default(value, updatedValue) {
  if (process.env.NODE_ENV !== 'production' && (0, _isParentValue.default)(value) && (0, _isParentValue.default)(updatedValue) && !(0, _equals.default)(value)(updatedValue)) {
    console.warn("Warning: please ensure you do not change the shape of the value, as changing the data shape or moving children within the data shape can cause dataparcels to misplace its keying and meta information!");
    /* eslint-disable-line */
  }
};

exports.default = _default;